<template>
    <dtunes-modal :dialog="dialog" @openModal="dialog = true" @closeModal="dialog = false">
        <template v-slot:button> Activate</template>
        <template v-slot:content>
            <v-card class="pad-10">
                <v-card-title class="d-flex justify-center">
                    <p class="text-center">ACTIVATE ADMIN</p>
                </v-card-title>
                <v-card-text>

                    <v-card-title class="d-flex justify-center">
                        <p class="text-center">ARE YOU SURE YOU WANT TO ACTIVATE THIS ADMIN ?</p>
                    </v-card-title>

                    <div style="background:#f7f7f7; padding:10px 10px 5px 10px">
                        <v-row>
                            <v-col cols="6">
                                <default-button @click="closeModalFunction()">Cancel</default-button>
                            </v-col>
                            <v-col cols="6">
                                <default-button :loading="loading" @click="activateAdmin()">Confirm</default-button>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
            </v-card>
        </template>
    </dtunes-modal>
</template>

<script>

// ========== IMPORT COMPONENTS =============
import DtunesModal from "@/components/dtunes-modal.vue";
import DefaultButton from "@/components/Buttons/default-button.vue";

// ============ IMPORT SERVICES ===============
import { StoresService } from "@/services";

export default {
    data: () => ({
        loading: false,
        dialog: false,
    }),
    components: {
        DtunesModal,
        DefaultButton,
    },
    props: {
        details: {
            type: Object,
            required: true
        },
    },
    mounted() {
        this.id = this.details.id;
    },
    methods: {

        // ============= METHOD TO DELETE GIFTCARD ======
        async activateAdmin() {
            try {
                this.loading = true
                const data = await StoresService.activateAdmin(this.details.email);
                this.loading = false
                this.$store.dispatch('toast', {
                    message: `Admin Activate sucessfully`,
                    variant: 'success'
                });
                this.dialog = false;
                this.$emit('closeModal');
                console.log(data);
            } catch (error) {
                this.loading = false
                console.log(error);
                this.$store.dispatch('toast', {
                    message: `Could not activate admin`,
                    variant: 'error'
                });
            }
        },
        closeModalFunction() {
            this.dialog = false;
            this.$emit('closeModal');
        }
    }
};
</script>